import './styles.css'

export function UnregisteredOrdersPage(): JSX.Element {
	return <div>Unregistered packages page</div>
}
